<template>
  <main>
    <div class="heading mb-xl">
      <h1 v-if="item">Chi tiết hiện vật: {{ extraData.name }}</h1>
      <el-row
        v-if="item"
type="flex"
justify="end">
        <el-button
type="primary"
@click="exportPDF">Xuất file PDF</el-button>
        <el-button
:disabled="!item.extra.link_3ds.length"
@click="visiblePreview3D = true">Xem 3D hiện vật</el-button>
      </el-row>
    </div>
    <div
v-if="item"
id="pdf-content">
      <div
id="print-only"
class="pdf-header">
        <div class="left">
          <p><strong>SỞ VĂN HÓA - THỂ THAO HÀ NỘI</strong></p>
          <p><strong>BẢO TÀNG HÀ NỘI</strong></p>
          <p>-----------------------------------------------</p>
        </div>
        <div class="center">
          <h2>PHIẾU HIỆN VẬT KHO CƠ SỞ</h2>
        </div>
        <div class="right">
          <img
src="@/assets/images/logo-bao-tang-ha-noi.jpg"
alt="Logo Bảo Tàng Hà Nội"
class="logo">
        </div>
      </div>
      <table
v-if="!loading"
id="table1"
class="info-table">
        <tr>
          <td>
            <p><strong>1. Tên gọi</strong>
              + Tên phổ thông: {{ extraData.name }}<br>
              + Tên địa phương: {{ extraData.local_name }}<br>
              + Tên khác: {{ extraData.other_name }}
            </p>
            <p><strong>2. Chủ sở hữu:</strong> {{ item.extra.owner | categoryName(allCategories) }}</p>
            <p><strong>3. Mã số</strong>
              + Số đăng ký: {{ extraData.register_number }}<br>
              + Số phân loại: {{ extraData.type_number }}<br>
              + Số sưu tầm: {{ extraData.collection_number }}<br>
              + Số khác: {{ extraData.other_number }}
            </p>
            <p><strong>4. Nguồn gốc:</strong> {{ extraData.root }}</p>
            <p><strong>5. Số lượng:</strong> {{ extraData.quantity }}</p>
            <p><strong>6. Thời gian đăng ký:</strong> {{ extraData.register_time | convertDateTime('DD/MM/YYYY') }}</p>
          </td>

          <td>
            <p><strong>7. Giám định</strong>
              + Cơ quan giám định: {{ item.extra.inspection_agency | categoryName(allCategories) }}<br>
              + Hội đồng giám định: {{ item.extra.appraisal_council }}<br>
              + Thời gian giám định: {{ item.extra.inspection_time | convertDateTime('DD/MM/YYYY') }}
            </p>
            <p><strong>8. Thời kỳ</strong>
              + Niên đại: {{ extraData.relative_chronology }}<br>
              + Giai đoạn: {{ extraData.stage }}<br>
              + Xuất xứ: {{ extraData.place_of_origin }}
            </p>
            <p><strong>9. Loại hiện vật</strong> {{ extraData.artifact_type | categoryName(allCategories) }}
            </p>
            <p><strong>10. Chất liệu:</strong> {{ extraData.material }}</p>
            <p><strong>11. Kích thước(cm), Trọng lượng(gr)</strong>
              + Dài: {{ extraData.long }}<br>
              + Cao: {{ extraData.high }}<br>
              + Rộng: {{ extraData.width }}<br>
              + Dày: {{ extraData.thickness }}<br>
              + Đkm: {{ extraData.face_diameter }}<br>
              + Đkd: {{ extraData.bottom_diameter }}<br>
              + Đkthân: {{ extraData.body_diameter }}
            </p>
          </td>

          <td>
            <div>
              <strong>12. Nội dung lịch sử:</strong>
              <div v-html="item.extra.history_content" />
            </div>
            <img
v-if="item.extra.file_images.length"
:src="imageUrl"
class="image-avatar"
alt="">
            <p><strong>13. Mô tả đặc điểm chính:</strong> {{ extraData.feature_description }}</p>
          </td>
        </tr>
      </table>
      <table
v-if="!loading"
id="table2"
class="info-table">
        <thead>
          <tr>
            <th colspan="2">THÔNG TIN BỔ SUNG</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p><strong>15. Nơi lưu giữ hiện tại:</strong> {{ extraData.storage_location }}</p>
              <p><strong>16. Chế độ bảo mật:</strong> {{ extraData.security_mode | categoryName(allCategories) }}</p>
              <p><strong>17. Tác giả:</strong>{{ extraData.author }}</p>
              <p><strong>18. Ngôn ngữ:</strong> {{ extraData.language | categoryName(allCategories) }}</p>
              <p><strong>19. Phân loại hiện vật:</strong> {{ item.artifact_classification }}
                + Chủ đề: {{ item.extra.topic }}<br>
                + Chuyên đề: {{ item.extra.specialized_subject | categoryName(allCategories) }}<br>
                + Sưu tập: {{ item.extra.collection | categoryName(allCategories) }}<br>
                + Nhân vật: {{ item.extra.character }}<br>
                + Địa danh: {{ item.extra.place_name }}
              </p>
            </td>

            <td>
              <p><strong>20. Tài liệu kèm theo:</strong>{{ extraData.doc_file }}</p>
              <p><strong>21. Ngày chụp hiện vật:</strong>{{ extraData.take_date | convertDateTime('DD/MM/YYYY') }}</p>
              <p><strong>22. Số hồ sơ:</strong> {{ extraData.preservation_record_number }}<br>
                + HS Kiểm kê: {{ extraData.inventory_file }}<br>
                + HS Bảo quản: {{ extraData.preservation_file }}<br>
                + HS Tu sửa: {{ extraData.restoration_file }}
              </p>
              <p><strong>23. Chế độ xử lý bảo quản:</strong> {{ extraData.preservation_treatment_mode }}<br>
                + Xử lý kỹ thuật: {{ extraData.technical_treatment }}<br>
                + Đã tu sửa: {{ extraData.restored }}
              </p>
              <p><strong>24. Loại Hình:</strong> {{ item.extra.root_type }}</p>
              <p><strong>25. Phương thức sưu tầm:</strong> {{ item.extra.collect_method | categoryName(allCategories) }}</p>
              <p><strong>26. Người sưu tầm:</strong> {{ item.extra.collect_person | categoryName(allCategories) }}</p>
              <p><strong>27. Người lập phiếu:</strong>
                {{ '' }}
              </p>
              <p><strong>28. Người thẩm định phiếu:</strong>
                {{ '' }}
              </p>
              <p><strong>29. Thông tin bổ sung:</strong></p>
              <p>{{ extraData.additional_information }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <Preview3DPopup
      v-if="item && item.extra.link_3ds.length"
      :list-link="item.extra.link_3ds"
      :visible="visiblePreview3D"
      @close="visiblePreview3D = false"
    />
  </main>

</template>

<script>
import html2pdf from "html2pdf.js";
import { mapGetters } from "vuex";
import Preview3DPopup from './popups/Preview3D.vue';

import constants from "@/config/constants";
import commonServices from "@/services/common";
import fileServices from '@/services/file';
import { objectPer, filePer, categoryPer } from "@/utils/permission";
export default {
  name: "SharedView",
  components: {
    Preview3DPopup
  },
  data() {
    return {
      item: null,
      isEdit: false,
      parentId: null,
      form: {},
      callingAPI: false,
      activeTab: "",
      filePermission: filePer(),
      categoryPermission: categoryPer(),
      loading: true,
      visiblePreview3D: false,
      imageUrl: ''
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    ...mapGetters("category", ["allCategories"]),
    config() {
      return this.allConfigs.find((c) => c.id === this.$route.meta.configId);
    },
    permission() {
      const objectType = constants.OBJECT_TYPES.find((t) => t.value === this.config.type);
      return objectPer(objectType.role_action);
    },

    extraData() {
      return this.item?.extra || null
    }
  },
  watch: {
    config: "loadData",
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (!this.config) {
        return;
      }
      this.loading = true;
      commonServices
        .show(this.config.type, this.$route.params.id)
        .then((response) => {
          this.item = response;
          if (response.extra && response.extra.file_images.length) {
            this.getImageUrl(response.extra.file_images[0])
          }
          this.loading = false;
        })
        .catch(() => {
          this.$router.push({ name: this.config.extra.key });
          this.loading = false;
        })
    },

    async getImageUrl(file) {
      try {
        const response = await fileServices.show(file.id)
        this.imageUrl = response.url
      } catch (error) {
        this.imageUrl = ''
      }
    },

    async exportPDF() {
      const element = document.getElementById("pdf-content");

      const opt = {
        margin: 10,
        filename: `${this.item?.extra?.name}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "landscape" }
      };

      html2pdf().set(opt).from(element).save();
    }
  }
}
</script>

<style lang="scss" scoped>
@media print {
  .page-break {
    page-break-before: always;
  }
}
.pdf-header {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 10px;
  display: flex;

  .left {
    text-align: center;
    font-size: 14px;
    line-height: 1.4;
  }

  .center {
    flex: 1;
    text-align: center;

    h2 {
      font-size: 18px;
      font-weight: bold;
      margin: 0;
    }
  }

  .right {
    text-align: right;
    font-size: 14px;
    line-height: 1.2;

    .logo {
      max-height: 150px;
      width: 100%;
      object-fit: contain;
      display: block;
      margin-left: auto;
      margin-bottom: 5px;
    }
  }
}

.info-table {
  width: 100%;
  border: 1px solid #000;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
  margin-bottom: 24px;

  th {
    border-bottom: 1px solid #000;
    text-align: center;
    padding: 8px;
    font-size: 16px;
  }

  td {
    border-left: 1px solid #000;
    vertical-align: top;
    padding: 10px;
    width: 33%;

    &:first-child {
      border-left: none;
    }

    p {
      margin: 0 0 10px;
      line-height: 1.5;
      font-size: 16px;

      strong {
        display: block;
        font-size: 20px;
        margin-bottom: 3px;
      }
    }

    .image-avatar {
      width: 100%;
      max-width: 70%;
      object-fit: cover;
    }
  }
}
</style>
